import { createAction } from '@ngrx/store';

export const leaveError = createAction('[ErrorActions] leaveError');
